import {isRcsProject} from "@/utils/index";

export const navigateToLogin = () => {
    //window.location.href = isRcsProject() ? "/control/login" : "/login";
}

export const navigateToBackendLogin = () => {
    //window.location.href = isRcsProject() ? "/backend/login" : "/system/login";
}

export const navigateToRegister= () => {
    //window.location.href = isRcsProject() ? "/control/register" : "/register"
}

export const navigateToDashboard = (isUser = false) => {
    if(isRcsProject()){
       window.location.href = isUser ? "/user/home" : "/backend/dashboard"
    }else {
       window.location.href = isUser ? "/app/dashboard" : "/backend/dashboard";
    }
}
